<template>
  <div v-if="visible" class="alert-group">
    <div class="alert alert-warning alert-dismissable">
      <div>
        <i class="fa fa-warning" style="color: #EF6C00; font-size: 20px; margin: 5px; margin-right: 10px;"></i>
        <span style="font-size: 14px; font-weight: 600;">Completar cadastro</span>
      </div>
      <p style="font-size: 12px; margin-left: 35px">Apenas o cadastro simplificado foi realizado. Complete seu cadastro e tenha melhores condições comerciais.
        <a :href='`/cadastro/${cnpj}`'>Clique aqui e complete o cadastro.</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertCompletarCadastro',
  props: [
    'visible',
    'cnpj'
  ]
}
</script>
